// extracted by mini-css-extract-plugin
export default {"wrapper":"Jk","form":"Kk","required":"Lk","label":"Mk","noMargin":"Nk","success":"Ok","circle":"Pk","successText":"Qk","smallprint":"Rk"};